import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { LEGAL } from "@/lib/legal";
import { LegalDocument } from "@/components/LegalDocument";

export function TermsDialog({ open, onOpenChange, docKey, onAccept }) {
  const doc = LEGAL[docKey];
  if (!doc) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl gap-0 overflow-hidden p-0" data-testid="terms-dialog">
        <DialogHeader className="border-b border-border px-6 py-4">
          <DialogTitle className="font-display text-xl text-navy">{doc.title}</DialogTitle>
          <DialogDescription className="sr-only">Please read the {doc.title} before accepting.</DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[62vh] px-6 py-5">
          <LegalDocument docKey={docKey} />
        </ScrollArea>
        <div className="flex justify-end gap-3 border-t border-border px-6 py-4">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm" data-testid="terms-dialog-close">Close</Button>
          {onAccept && (
            <Button onClick={onAccept} className="rounded-sm bg-brand text-white hover:bg-brand-hover" data-testid="terms-dialog-accept">I Agree &amp; Accept</Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
